import {
    GET_CLIENTS_SUCCESS,
    GET_CLIENT_BY_ID_SUCCESS,
    GET_CLIENT_CONTACTS_SUCCESS,
    GET_CLIENT_ENROLLMENT_SUCCESS,
    CREATE_CLIENT_CONTACT_SUCCESS,
    GET_ASSIGNED_STAFFS_SUCCESS,
    GET_BASIC_CLIENTS_SUCCESS,
    GET_BASIC_ACTIVE_CLIENTS_SUCCESS,
    GET_CLIENT_AUTHORIZATIONS_SUCCESS,
    GITE_CLIENT_AUTH_FILES_SUCCESS,
    GET_CLIENT_AUTHORIZATIONS_APPT_SUCCESS,
    GET_AUTH_UNIT_INFO_SUCCESS,
    GET_ENROLLMENT_PAYERS_SUCCESS,
    GET_CLIENT_FORMS_SUCCESS,
    GET_CLIENT_CONTACTS_INFO_SUCCESS,
    GET_CLIENT_SECTIONS_SUCCESS,
    REMOVE_CLIENT_AUTHORIZATIONS, GET_CLIENTS_EXPIRATION_SUCCESS,
    GET_CLIENT_ALL_NOTES_SUCCESS,
    GET_CLIENT_SCHEDULING_ADDRESS_SUCCESS,
    GET_AUTH_UTILIZATION_SUCCESS,
} from './client.types';

const initialState = {
    clientList: [],
    clientExpiration: [],
    clientItemInfo: {},
    clientContacts: [],
    clientEnrollment: [],
    clientEnrollmentPayers: [],
    clientsAuthorizations: [],
    clientsAuthorizationsAppt: [],
    authUtilization: { clients: [], count: 0 },
    clientsNotes: [],

    clientStaffs: null,
    basicClients: [],
    basicActiveClients: [],
    clientsAuthorizationAppt: [],
    clientsAuthorizationFiles: [],
    clientForms: [],
    clientContactInfo: [],
    clientSections: [],
    // { selected: { type, refId, name } | null, options: [{ id, type, label, address }] }
    clientSchedulingAddress: null,
};

export const clientReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CLIENTS_SUCCESS:
            return {
                ...state,
                clientList: action.payload,
            };

        case GET_CLIENTS_EXPIRATION_SUCCESS:
            return {
                ...state,
                clientExpiration: action.payload,
            };

        case GET_BASIC_CLIENTS_SUCCESS:
            return {
                ...state,
                basicClients: action.payload,
            };

        case GET_BASIC_ACTIVE_CLIENTS_SUCCESS:
            return {
                ...state,
                basicActiveClients: action.payload,
            };

        case GET_CLIENT_BY_ID_SUCCESS:
            return {
                ...state,
                clientItemInfo: action.payload,
            };
        case GET_CLIENT_CONTACTS_INFO_SUCCESS:
            return {
                ...state,
                clientContactInfo: action.payload,
            };
        case GET_CLIENT_CONTACTS_SUCCESS:
            return {
                ...state,
                clientContacts: action.payload,
            };
        case GET_CLIENT_SCHEDULING_ADDRESS_SUCCESS:
            return {
                ...state,
                clientSchedulingAddress: action.payload,
            };
        case CREATE_CLIENT_CONTACT_SUCCESS:
            return {
                ...state,
                clientContacts: [...state.clientContacts, action.payload],
            };
        case GET_CLIENT_ENROLLMENT_SUCCESS:
            return {
                ...state,
                clientEnrollment: action.payload,
            };

        case GET_ENROLLMENT_PAYERS_SUCCESS:
            return {
                ...state,
                clientEnrollmentPayers: action.payload,
            };

        case GET_ASSIGNED_STAFFS_SUCCESS:
            return {
                ...state,
                clientStaffs: action.payload,
            };
        /** End */

        case GET_CLIENT_AUTHORIZATIONS_SUCCESS:
            return {
                ...state,
                clientsAuthorizations: action.payload,
            };

        case GET_AUTH_UTILIZATION_SUCCESS:
            return {
                ...state,
                authUtilization: {
                    clients: action.payload.append
                        ? [...state.authUtilization.clients, ...(action.payload.data?.clients || [])]
                        : action.payload.data?.clients || [],
                    count: action.payload.data?.count || 0,
                },
            };

        case GET_CLIENT_AUTHORIZATIONS_APPT_SUCCESS:
            return {
                ...state,
                clientsAuthorizationsAppt: action.payload,
            };
        case REMOVE_CLIENT_AUTHORIZATIONS:
            return {
                ...state,
                clientsAuthorizationsAppt: [],
            };

        case GITE_CLIENT_AUTH_FILES_SUCCESS:
            return {
                ...state,
                clientsAuthorizationFiles: action.payload,
            };

        case GET_AUTH_UNIT_INFO_SUCCESS:
            return {
                ...state,
                clientsAuthorizationAppt: action.payload,
            };
        case GET_CLIENT_FORMS_SUCCESS:
            return {
                ...state,
                clientForms: action.payload,
            };
        case GET_CLIENT_SECTIONS_SUCCESS:
            return {
                ...state,
                clientSections: action.payload,
            };
        case GET_CLIENT_ALL_NOTES_SUCCESS:
            return {
                ...state,
                clientsNotes: action.payload,
            };
        default:
            return state;
    }
};
